import React from 'react';
import styles from '@/styles/components/SurveyPurposeElement.module.css';

export interface SurveyPurposeElementData {
  title: string;
  text: string;
}

export const SurveyPurposeElement: React.FC<
  SurveyPurposeElementData
> = props => {
  return (
    <div className={styles.purposeContainer}>
      <span className={styles.purposeTitle}>{props.title}</span>
      <span className={styles.purposeText}>{props.text}</span>
    </div>
  );
};
